import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { reports } from "../../../components/Report.js";

// เพดานล่างของข้อมูล 1 มีนาคม 2569 — API ไม่ดึงบิลก่อนวันนี้
// ไม่ใช่วันเริ่มงวด: ยอดหนี้ยกมา = บิลตั้งแต่วันนี้ถึงวันเริ่มงวดที่ผู้ใช้เลือก
// ถ้าตั้งสองค่านี้เท่ากัน ช่วง "ก่อนงวด" จะว่างและยอดหนี้ยกมาเป็น 0 เสมอ
const REPORT_START_DATE = "2026-03-01";

// ชื่อลูกค้าที่ไม่ต้องแสดงในรายงานแบบชำระเงินเชื่อ (ลูกค้าเงินสด / ไม่ระบุชื่อ)
const EXCLUDED_CREDIT_CUSTOMER_NAMES = ["สด", "ไม่ระบุชื่อ", "-"];

// ตัวเลือกการเรียงลำดับของตารางรายงาน
const SORT_OPTIONS = [
  { value: "customer_code", label: "รหัสลูกค้า" },
  { value: "full_name", label: "ชื่อเต็มลูกค้า" },
  { value: "brought_forward", label: "ยอดหนี้ยกมา" },
  { value: "total_data2", label: "ยอดขายในงวด" },
  { value: "total_data3", label: "ยอดชำระ/ลดหนี้" },
  { value: "carried_forward", label: "ยอดหนี้ยกไป" },
];
const SORT_ORDER_OPTIONS = [
  { value: "asc", label: "น้อยไปมาก (ก-ฮ)" },
  { value: "desc", label: "มากไปน้อย (ฮ-ก)" },
];

export default class Billings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_view: false,

      filter_search: "",
      filter_start_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        "yyyy-mm-dd",
        "en",
      ),
      filter_end_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        "yyyy-mm-dd",
        "en",
      ),
      filter_status: "",
      filter_warehouse_id: "",
      filter_payment_type: "ชำระเงินทันที,ชำระมัดจำ",
      filter_sort_by: "customer_code",
      filter_sort_order: "asc",

      data_customer: [],
      data_sale: [],
      data_warehouse: [],
      data_debtor: [],
    };
    this.tableRef = React.createRef();
    this.tableRefDebtor = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_warehouse_id,
      filter_payment_type,
    } = this.state;
    let data_customer, data_sale, data_payment, data_warehouse, data_debtor;
    loading(true);
    let [result_customer, result_sale, result_payment, result_warehouse] =
      await Promise.all([
        GET("admin/setting/customers/list", { page: 0, data_search: "" }),
        GET("admin/sales/list", {
          page: 0,
          data_search: "",
          start_date: REPORT_START_DATE,
          end_date: format_date(filter_end_date, "yyyy-mm-dd", "en"),
          warehouse_id: "",
          payment_type: filter_payment_type,
          status_code: "รอชำระ,รอสั่งสินค้า,คืนสินค้า,ใบแจ้งหนี้,เสร็จสิ้น",
          withdrawal_type: "ขายหน้าร้าน,รอสั่งสินค้า",
        }),
        GET("admin/sales/list-payment", {
          page: 0,
          data_search: "",
          start_date: REPORT_START_DATE,
          end_date: format_date(filter_end_date, "yyyy-mm-dd", "en"),
          payment_type: "",
        }),
        GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      ]);
    // ไม่มี Z ต่อท้าย JS จึงอ่านเป็นเวลาท้องถิ่น ตรงกับวันที่ผู้ใช้เลือกจากปฏิทิน
    const startTime = new Date(`${filter_start_date}T00:00:00`).getTime();
    const endTime = new Date(`${filter_end_date}T23:59:59.999`).getTime();

    if (result_customer?.status) {
      data_customer = result_customer.data;
    }
    if (result_sale?.status) {
      data_sale = result_sale.data.filter(
        (e) => !filter_warehouse_id || e.warehouse?.uid === filter_warehouse_id,
      );
    }
    if (result_payment?.status) {
      data_payment = result_payment.data;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    data_customer = data_customer.map((e) => {
      // บิลก่อนงวด ใช้ < ไม่ใช่ <= ไม่งั้นบิลที่ตรงเส้นแบ่งพอดีจะถูกนับทั้งสองถัง
      let data_1 = data_sale.filter((item) => {
        if (item.customer?.uid !== e.uid) return false;
        const createdTime = new Date(item.created_at).getTime();
        return createdTime < startTime;
      });
      const data_1_uids = new Set(data_1.map((d) => d.uid));
      let payment_1 = data_payment
        .filter((item) => {
          if (!data_1_uids.has(item?.sale?.uid)) return false;
          const createdTime = new Date(item.created_at).getTime();
          return createdTime < startTime;
        })
        .map((e) => ({
          amount:
            Number(e.cash_amount) +
            Number(e.transfer_amount) +
            Number(e.credit_amount),
        }));

      let data_2 = data_sale.filter((item) => {
        if (item.customer?.uid !== e.uid) return false;
        const createdTime = new Date(item.created_at).getTime();
        return createdTime >= startTime && createdTime <= endTime;
      });

      // นับการชำระของบิลทั้งสองถัง ไม่งั้นสมการ ยกมา + ขายในงวด − ชำระ = ยกไป ไม่สมดุล
      const all_sale_uids = new Set([
        ...data_1_uids,
        ...data_2.map((d) => d.uid),
      ]);
      let payment_3 = data_payment
        .filter((item) => {
          if (!all_sale_uids.has(item?.sale?.uid)) return false;
          const createdTime = new Date(item.created_at).getTime();
          return createdTime >= startTime && createdTime <= endTime;
        })
        .map((e) => ({
          amount:
            Number(e.cash_amount) +
            Number(e.transfer_amount) +
            Number(e.credit_amount),
        }));

      return {
        ...e,

        data1: data_1,
        total_data1: total(data_1, "amount"),
        payment_data1: total(payment_1, "amount"),

        data2: data_2,
        total_data2: total(data_2, "amount"),

        total_data3: total(payment_3, "amount"),
      };
    });

    if (filter_payment_type === "ชำระเงินเชื่อ") {
      data_customer = data_customer.filter((item) => {
        const full_name = (item.full_name || "").trim();
        return (
          full_name && !EXCLUDED_CREDIT_CUSTOMER_NAMES.includes(full_name)
        );
      });
    }

    data_debtor = data_customer;

    data_customer = data_customer.filter(
      (item) =>
        item.total_data1 ||
        item.payment_data1 ||
        item.total_data2 ||
        item.total_data3,
    );

    this.setState({
      data_customer,
      data_warehouse,
      data_debtor
    });
    loading(false);
  };

  SortData = (data) => {
    const { filter_sort_by, filter_sort_order } = this.state;
    const direction = filter_sort_order === "desc" ? -1 : 1;
    const sort_value = (item) => {
      switch (filter_sort_by) {
        case "full_name":
          return item.full_name || "";
        case "brought_forward":
          return Number(item.total_data1) - Number(item.payment_data1);
        case "total_data2":
          return Number(item.total_data2);
        case "total_data3":
          return Number(item.total_data3);
        case "carried_forward":
          return (
            Number(item.total_data1) -
            Number(item.payment_data1) +
            Number(item.total_data2) -
            Number(item.total_data3)
          );
        default:
          return item.customer_code || "";
      }
    };
    return [...(data || [])].sort((a, b) => {
      const value_a = sort_value(a);
      const value_b = sort_value(b);
      if (typeof value_a === "number" && typeof value_b === "number") {
        return (value_a - value_b) * direction;
      }
      return String(value_a).localeCompare(String(value_b), "th") * direction;
    });
  };

  ExportPDF = async () => {
    const table = this.tableRef.current;
    if (!table) return [];

    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    const obj = {
      table: {
        headerRows: 1,
        widths: ["auto", 140, 65, 65, 65, 65],
        body: [
          [
            { text: "รหัสลูกค้า", alignment: "center" },
            { text: "ชื่อเต็มลูกค้า", alignment: "center" },
            { text: "ยอดหนี้ยกมา", alignment: "center" },
            { text: "ยอดขายในงวด", alignment: "center" },
            { text: "ยอดชำระ/ลดหนี้", alignment: "center" },
            { text: "ยอดหนี้ยกไป", alignment: "center" },
          ],
          ...data_list.map((item, index) => {
            let border = [1, 0, 1, 0];
            let color = "#ffffff";
            if (index === data_list.length - 1) {
              border = [1, 0, 1, 1];
            }
            return [
              {
                text: item[0],
                alignment: "left",
                fillColor: color,
                border: [1, border[1], border[2], border[3]],
              },
              { text: item[1], alignment: "left", fillColor: color, border },
              { text: item[2], alignment: "right", fillColor: color, border },
              { text: item[3], alignment: "right", fillColor: color, border },
              { text: item[4], alignment: "right", fillColor: color, border },
              {
                text: item[5],
                alignment: "right",
                fillColor: color,
                border: [border[0], border[1], 1, border[3]],
              },
            ];
          }),
        ],
      },
    };
    reports("รายงานสถานะลูกหนี้ทั้งหมด", obj, 14, "portrait");
  };
  ExportPDFDebtor = async () => {
    const table = this.tableRefDebtor.current;
    if (!table) return [];

    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    const obj = {
      table: {
        headerRows: 1,
        widths: ["auto", 140, 65, 65, 65, 65],
        body: [
          [
            { text: "รหัสลูกค้า", alignment: "center" },
            { text: "ชื่อเต็มลูกค้า", alignment: "center" },
            { text: "ยอดหนี้ยกมา", alignment: "center" },
            { text: "ยอดขายในงวด", alignment: "center" },
            { text: "ยอดชำระ/ลดหนี้", alignment: "center" },
            { text: "ยอดหนี้ยกไป", alignment: "center" },
          ],
          ...data_list.map((item, index) => {
            let border = [1, 0, 1, 0];
            let color = "#ffffff";
            if (index === data_list.length - 1) {
              border = [1, 0, 1, 1];
            }
            return [
              {
                text: item[0],
                alignment: "left",
                fillColor: color,
                border: [1, border[1], border[2], border[3]],
              },
              { text: item[1], alignment: "left", fillColor: color, border },
              { text: item[2], alignment: "right", fillColor: color, border },
              { text: item[3], alignment: "right", fillColor: color, border },
              { text: item[4], alignment: "right", fillColor: color, border },
              {
                text: item[5],
                alignment: "right",
                fillColor: color,
                border: [border[0], border[1], 1, border[3]],
              },
            ];
          }),
        ],
      },
    };
    reports("รายชื่อลูกหนี้ทั้งหมด", obj, 14, "portrait");
  };
  render() {
    const {
      filter_payment_type,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_sort_by,
      filter_sort_order,
      data_customer,
      data_sale,
      data_warehouse,
      data_debtor
    } = this.state;
    const data_customer_sorted = this.SortData(data_customer);
    const data_debtor_sorted = this.SortData(data_debtor);
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายงานสถานะลูกหนี้</h4>
              <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light mb-3">
                <button
                  className={`btn ${
                    filter_payment_type === "ชำระเงินทันที,ชำระมัดจำ"
                      ? "btn-dark"
                      : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState(
                      {
                        filter_payment_type: "ชำระเงินทันที,ชำระมัดจำ",
                      },
                      () => {
                        this.Get(1);
                      },
                    );
                  }}
                >
                  ชำระทันที & มัดจำ
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    filter_payment_type === "ชำระเงินเชื่อ"
                      ? "btn-dark"
                      : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState(
                      {
                        filter_payment_type: "ชำระเงินเชื่อ",
                      },
                      () => {
                        this.Get(1);
                      },
                    );
                  }}
                >
                  ชำระเงินเชื่อ
                </button>
              </div>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="เรียงตาม..."
                  options={SORT_OPTIONS}
                  default={false}
                  onChange={(e) => {
                    this.setState({ filter_sort_by: e });
                  }}
                  value={filter_sort_by}
                />
              </div>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="ลำดับ..."
                  options={SORT_ORDER_OPTIONS}
                  default={false}
                  onChange={(e) => {
                    this.setState({ filter_sort_order: e });
                  }}
                  value={filter_sort_order}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>

              <div className="ms-auto d-flex">
                {filter_payment_type === "ชำระเงินเชื่อ" &&(
                <button
                  className="btn btn-warning px-3 mb-2 me-2"
                  onClick={() => this.ExportPDFDebtor()}
                >
                  PDF รายชื่อลูกหนี้
                </button>
                )}
                 {filter_payment_type === "ชำระเงินเชื่อ" &&(
                  <div className="me-2">
                <DownloadTableExcel
                  filename="รายการลูกหนี้"
                  sheet="รายการลูกหนี้"
                  currentTableRef={this.tableRefDebtor.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel รายชื่อลูกหนี้</button>
                </DownloadTableExcel>
                </div>
                )}

                <button
                  className="btn btn-warning px-3 mb-2 me-2"
                  onClick={() => this.ExportPDF()}
                >
                  PDF
                </button>
                <DownloadTableExcel
                  filename="รายการสถานะลูกหนี้"
                  sheet="รายการสถานะลูกหนี้"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{ maxHeight: "70vh" }}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap text-center">รหัสลูกค้า</td>
                    <td className="text-nowrap text-center">ชื่อเต็มลูกค้า</td>
                    <td className="text-nowrap text-center">ยอดหนี้ยกมา</td>
                    <td className="text-nowrap text-center">ยอดขายในงวด</td>
                    <td className="text-nowrap text-center">ยอดชำระ/ลดหนี้</td>
                    <td className="text-nowrap text-center">ยอดหนี้ยกไป</td>
                  </tr>
                </thead>
                <tbody>
                  {data_customer_sorted?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.customer_code || "-"}
                      </td>
                      <td className="text-nowrap">{item.full_name || "-"}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.total_data1 - item.payment_data1)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.total_data2)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.total_data3)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          item.total_data1 -
                            item.payment_data1 +
                            item.total_data2 -
                            item.total_data3,
                        )}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="bg-primary-light"></td>
                    <td className="text-end bg-primary-light">รวมทั้งสิ้น</td>
                    <td className="text-end bg-primary-light">
                      {toFixed(
                        total(data_customer, "total_data1") -
                          total(data_customer, "payment_data1"),
                      )}
                    </td>
                    <td className="text-end bg-primary-light">
                      {toFixed(total(data_customer, "total_data2"))}
                    </td>
                    <td className="text-end bg-primary-light">
                      {toFixed(total(data_customer, "total_data3"))}
                    </td>
                    <td className="text-end bg-primary-light">
                      {toFixed(
                        total(data_customer, "total_data1") -
                          total(data_customer, "payment_data1") +
                          total(data_customer, "total_data2") -
                          total(data_customer, "total_data3"),
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style={{opacity: 0, height:1, overflow: "hidden"}}>
                <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRefDebtor}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap text-center">รหัสลูกค้า</td>
                    <td className="text-nowrap text-center">ชื่อเต็มลูกค้า</td>
                    <td className="text-nowrap text-center">ยอดหนี้ยกมา</td>
                    <td className="text-nowrap text-center">ยอดขายในงวด</td>
                    <td className="text-nowrap text-center">ยอดชำระ/ลดหนี้</td>
                    <td className="text-nowrap text-center">ยอดหนี้ยกไป</td>
                  </tr>
                </thead>
                <tbody>
                  {data_debtor_sorted?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.customer_code || "-"}
                      </td>
                      <td className="text-nowrap">{item.full_name || "-"}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.total_data1 - item.payment_data1)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.total_data2)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(item.total_data3)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          item.total_data1 -
                            item.payment_data1 +
                            item.total_data2 -
                            item.total_data3,
                        )}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className="bg-primary-light"></td>
                    <td className="text-end bg-primary-light">รวมทั้งสิ้น</td>
                    <td className="text-end bg-primary-light">
                      {toFixed(
                        total(data_customer, "total_data1") -
                          total(data_customer, "payment_data1"),
                      )}
                    </td>
                    <td className="text-end bg-primary-light">
                      {toFixed(total(data_customer, "total_data2"))}
                    </td>
                    <td className="text-end bg-primary-light">
                      {toFixed(total(data_customer, "total_data3"))}
                    </td>
                    <td className="text-end bg-primary-light">
                      {toFixed(
                        total(data_customer, "total_data1") -
                          total(data_customer, "payment_data1") +
                          total(data_customer, "total_data2") -
                          total(data_customer, "total_data3"),
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
